import { SystemDiagnosticMetric } from './SystemDiagnosticMetric'
import { SYSTEM_DIAGNOSTIC_CATEGORIES, SystemDiagnosticCategoryEnum } from '@/enums'
import { SystemDiagnosticCategoryDataType } from '@/types'

export class SystemDiagnosticCategory {
    key: SystemDiagnosticCategoryEnum

    title: string

    metrics: SystemDiagnosticMetric[]

    constructor(data: SystemDiagnosticCategoryDataType) {
        this.key = data.key
        this.metrics = data.metrics.map(item => new SystemDiagnosticMetric(item))
        const category = SYSTEM_DIAGNOSTIC_CATEGORIES
            .find(item => item.key === data.key)
        this.title = category?.title || this.key
    }

    get normalMetrics() {
        return this.metrics.filter(item => item.isNormal)
    }

    get erroredMetrics() {
        return this.metrics.filter(item => item.isErrored)
    }
}
